import { appWithTranslation } from 'next-i18next';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import '../styles/app.scss';
import 'tailwindcss/tailwind.css';
import React, { useEffect } from 'react';
import Script from 'next/script';
import { useRouter } from 'next/router';
import type { AppProps } from 'next/app';
import AppMain from '../components/AppMain';
import { GA_MEASUREMENT_ID, pageview } from '../lib/gtag';

Bugsnag.start({
  apiKey: '36effa0432a468c2cca9d3f3f70a8d00',
  plugins: [new BugsnagPluginReact()],
  // otherOptions: value
});

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  useEffect(() => {
    if (!GA_MEASUREMENT_ID) {
      return;
    }
    const handleRouteChange = (url: string) => {
      pageview(url, router.locale);
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    pageview(window.location.pathname + window.location.search, router.locale);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, router.locale]);

  const gaScripts =
    process.env.NODE_ENV === 'production' && GA_MEASUREMENT_ID ? (
      <>
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
          strategy="afterInteractive"
        />
        <Script id="ga4-init" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = window.gtag || gtag;
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', {
              cookie_domain: 'lingualbox.com',
              send_page_view: false
            });
          `}
        </Script>
      </>
    ) : null;

  if (process.env.NODE_ENV === 'production') {
    const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(
      React as any,
    );
    return (
      <ErrorBoundary>
        {gaScripts}
        <AppMain Component={Component} pageProps={pageProps} />
      </ErrorBoundary>
    );
  }
  return (
    <>
      {gaScripts}
      <AppMain Component={Component} pageProps={pageProps} />
    </>
  );
}

export default appWithTranslation(MyApp);
